module.exports = __webpack_public_path__ + "img/base_inventario.649dd852.gif";